import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_CRS_CLUSTER_INFORMATION,
  GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA,
  GET_CRS_FEATURE_CATEGORY_CODES,
  GET_CRS_FEATURE_CODES,
  GET_CRS_HIST_ALERT,
  GET_CRS_MODEL_EXPLAINABILITY_DATA,
  GET_CRS_MODEL_EXPLAINABILITY_STATS,
  GET_CRS_RISK_INDICATOR,
  GET_CRS_RISK_INDICATOR_GRAPH,
  GET_CRS_TRANSACTION,
  GET_CRS_TRANSACTION_PRODUCT_MAPPING,
  GET_CRS_TRANSACTION_TYPES,
  GET_CRS_TREND_ANALYSIS_DATA,
  GET_CUSTOMER_PROFILE,
  GET_ASSOCIATED_CUSTOMERS,
  getCRSAlertHistoryData,
  getCRSClusterInformationData,
  getCRSClusterViewDescriptionCodesData,
  getCRSFeatureCategoryCodesData,
  getCRSFeatureCodesData,
  getCRSModelExplainabilityData,
  getCRSModelExplainabilityStats,
  getCRSRiskIndicatorData,
  getCRSRiskIndicatorGraphData,
  getCRSTransactionHistoryData,
  getCRSTransactionProductMappingData,
  getCRSTransactionTypesData,
  getCRSTrendAnalysisData,
  getCustomerProfileData,
  getAssociatedCustomersData,
  UPDATE_CRS_RISK_SCORE_HISTORY,
  updateCRSRiskScoreHistory,
  PUT_RISK_SCORE_ACCEPTANCE,
  putRiskScoreAcceptance,
  GET_CRS_RISK_SCORE_HISTORY,
  getCRSRiskScoreHistory
} from '../../redux/actions/crs/crsRiskDetail';
import * as api from '../../services/crs/crsRiskDetail';
import { CRS_CONSTANTS } from '../../pages/constants/crsContants';
import {
  getCRSRiskIndicatorsGraph,
  riskIndicatorsModule
} from '../../services/crs/apiModules/RiskDetailModules/riskIndicatorsModule';

const { GET_FAILURE_DATA, GET_DATA, GET_SUCCESS_DATA } = CRS_CONSTANTS;

const networkLayerObject = new api.NetworkLayer();

/**** CUSTOMER PROFILE SAGA START ****/
function* getCustomerProfileWorker(payload) {
  try {
    const response = yield call(networkLayerObject.customerProfileAPI, payload);
    yield put(getCustomerProfileData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCustomerProfileData(error, GET_FAILURE_DATA));
  }
}

export function* watchCustomerProfileView() {
  yield takeEvery(GET_CUSTOMER_PROFILE, function* ({ payload }) {
    yield fork(getCustomerProfileWorker, payload);
  });
}

/****** CUSTOMER PROFILE SAGA END ********/

/**** ASSOCIATED CUSTOMERS SAGA START ****/
function* getAssociatedCustomersWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.associatedCustomersAPI,
      payload
    );
    yield put(getAssociatedCustomersData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getAssociatedCustomersData(error, GET_FAILURE_DATA));
  }
}

export function* watchAssociatedCustomersView() {
  yield takeEvery(GET_ASSOCIATED_CUSTOMERS, function* ({ payload }) {
    yield fork(getAssociatedCustomersWorker, payload);
  });
}
/****** ASSOCIATED CUSTOMERS SAGA END ********/

/*** CUSTOMER CLUSTER INFORMATION SAGA START **/

function* getClusterInformationWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.clusterInformationAPI,
      payload
    );
    yield put(getCRSClusterInformationData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSClusterInformationData(error, GET_FAILURE_DATA));
  }
}

export function* watchClusterInformationView() {
  yield takeEvery(GET_CRS_CLUSTER_INFORMATION, function* ({ payload }) {
    yield fork(getClusterInformationWorker, payload);
  });
}

/**
 * CUSTOMER CLUSTER INFORMATION SAGA END
 * */

/**
 * getCRSFeatureCodesWorker SAGA START
 * */

function* getCRSFeatureCodesWorker(payload) {
  try {
    const response = yield call(networkLayerObject.featureCodesAPI, payload);
    yield put(getCRSFeatureCodesData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSFeatureCodesData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSFeaturesCodesView() {
  yield takeEvery(GET_CRS_FEATURE_CODES, function* ({ payload }) {
    yield fork(getCRSFeatureCodesWorker, payload);
  });
}

/*** getCRSFeatureCodesWorker SAGA END ***/

/**
 * clusterViewDescriptionCodesAPI SAGA START
 * */

function* getClusterViewDescriptionCodesAPIWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.clusterViewDescriptionCodesAPI,
      payload
    );
    yield put(
      getCRSClusterViewDescriptionCodesData(response, GET_SUCCESS_DATA)
    );
  } catch (error) {
    yield put(getCRSClusterViewDescriptionCodesData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSClusterViewDescriptionCodesAPIView() {
  yield takeEvery(
    GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA,
    function* ({ payload }) {
      yield fork(getClusterViewDescriptionCodesAPIWorker, payload);
    }
  );
}

/*** clusterViewDescriptionCodesAPI SAGA END ***/

/*** getCRSTransactionProductMapping SAGA START **/

function* getCRSTransactionProductMappingWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.transactionProductMappingAPI,
      payload
    );
    yield put(getCRSTransactionProductMappingData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSTransactionProductMappingData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSTransactionProductMappingView() {
  yield takeEvery(GET_CRS_TRANSACTION_PRODUCT_MAPPING, function* ({ payload }) {
    yield fork(getCRSTransactionProductMappingWorker, payload);
  });
}

/*** getCRSTransactionProductMapping SAGA END ****/

/***** getCRSFeatureCategoryCodes SAGA START ****/

function* getCRSFeatureCategoryCodesWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.featureCategoryCodesAPI,
      payload
    );
    yield put(getCRSFeatureCategoryCodesData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSFeatureCategoryCodesData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSFeatureCategoryCodesView() {
  yield takeEvery(GET_CRS_FEATURE_CATEGORY_CODES, function* ({ payload }) {
    yield fork(getCRSFeatureCategoryCodesWorker, payload);
  });
}

/***** getCRSFeatureCategoryCodes SAGA end****/

/**** getCRSTransactionTypes SAGA START ****/

function* getCRSTransactionTypesWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.transactionTypesAPI,
      payload
    );
    yield put(getCRSTransactionTypesData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSTransactionTypesData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSTransactionTypesView() {
  yield takeEvery(GET_CRS_TRANSACTION_TYPES, function* ({ payload }) {
    yield fork(getCRSTransactionTypesWorker, payload);
  });
}

/*** getCRSTransactionTypes SAGA END ***/

/**** CRSTransactionHistory SAGA START ****/

function* getCRSTransactionHistoryWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.transactionHistoryAPI,
      payload
    );
    yield put(getCRSTransactionHistoryData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSTransactionHistoryData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSTransactionHistoryView() {
  yield takeEvery(GET_CRS_TRANSACTION, function* ({ payload }) {
    yield fork(getCRSTransactionHistoryWorker, payload);
  });
}

/*** CRSTransactionHistory SAGA END ***/

/**** alertHistoryModule SAGA START ****/

function* getCRSCustomerAlertHistoryWorker(payload) {
  try {
    const response = yield call(networkLayerObject.alertHistoryAPI, payload);
    yield put(getCRSAlertHistoryData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSAlertHistoryData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSCustomerAlertHistoryView() {
  yield takeEvery(GET_CRS_HIST_ALERT, function* ({ payload }) {
    yield fork(getCRSCustomerAlertHistoryWorker, payload);
  });
}

/*** alertHistoryModule SAGA END ***/

/**** riskIndicatorsModule SAGA START ****/

function* getCRSRiskIndicatorsWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.riskIndicatorsListAPI,
      payload
    );
    yield put(getCRSRiskIndicatorData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSRiskIndicatorData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSRiskIndicatorsView() {
  yield takeEvery(GET_CRS_RISK_INDICATOR, function* ({ payload }) {
    yield fork(getCRSRiskIndicatorsWorker, payload);
  });
}

/*** riskIndicatorsModule SAGA END ***/

/**** getCRSRiskIndicatorsGraph SAGA START ****/

function* getCRSRiskIndicatorsGraphWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.riskIndicatorGraphAPI,
      payload
    );
    yield put(getCRSRiskIndicatorGraphData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSRiskIndicatorGraphData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSRiskIndicatorsGraphView() {
  yield takeEvery(GET_CRS_RISK_INDICATOR_GRAPH, function* ({ payload }) {
    yield fork(getCRSRiskIndicatorsGraphWorker, payload);
  });
}

/*** getCRSRiskIndicatorsGraph SAGA END ***/

/**** modelExplainAbilityModule SAGA START ****/

function* getCRSModelExplainAbilityWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.modelExplainAbilityAPI,
      payload
    );
    yield put(getCRSModelExplainabilityData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSModelExplainabilityData(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSModelExplainAbilityView() {
  yield takeEvery(GET_CRS_MODEL_EXPLAINABILITY_DATA, function* ({ payload }) {
    yield fork(getCRSModelExplainAbilityWorker, payload);
  });
}

function* getCRSModelExplainAbilityStatsWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.modelExplainAbilityStatsAPI,
      payload
    );
    yield put(getCRSModelExplainabilityStats(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSModelExplainabilityStats(error, GET_FAILURE_DATA));
  }
}

export function* watchCRSModelExplainAbilityStatsView() {
  yield takeEvery(GET_CRS_MODEL_EXPLAINABILITY_STATS, function* ({ payload }) {
    yield fork(getCRSModelExplainAbilityStatsWorker, payload);
  });
}

/*** getCRSRiskIndicatorsGraph SAGA END ***/

/**** trendAnalysisModule SAGA START ****/
function* getTrendAnalysisDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.trendAnalysisAPI, payload);
    yield put(getCRSTrendAnalysisData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSTrendAnalysisData(error, GET_FAILURE_DATA));
  }
}

export function* watchTrendAnalysisDataView() {
  yield takeEvery(GET_CRS_TREND_ANALYSIS_DATA, function* ({ payload }) {
    yield fork(getTrendAnalysisDataWorker, payload);
  });
}

/*** trendAnalysisModule SAGA END ***/

/**** ACCEPT RISK SCORE SAGA START ****/
function* acceptRiskScoreWorker(payload) {
  try {
    const response = yield call(networkLayerObject.acceptRiskScoreAPI, payload);
    yield put(putRiskScoreAcceptance(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(putRiskScoreAcceptance(error, GET_FAILURE_DATA));
  }
}

export function* watchAcceptRiskScoreView() {
  yield takeEvery(PUT_RISK_SCORE_ACCEPTANCE, function* ({ payload }) {
    yield fork(acceptRiskScoreWorker, payload);
  });
}
/*** ACCEPT RISK SCORE SAGA END ***/

/**** RISK SCORE HISTORY SAGA START ****/
function* updateRiskScoreHistoryWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.updateRiskScoreHistoryAPI,
      payload
    );
    yield put(updateCRSRiskScoreHistory(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(updateCRSRiskScoreHistory(error, GET_FAILURE_DATA));
  }
}

export function* watchUpdateRiskScoreHistoryView() {
  yield takeEvery(UPDATE_CRS_RISK_SCORE_HISTORY, function* ({ payload }) {
    yield fork(updateRiskScoreHistoryWorker, payload);
  });
}

function* getRiskScoreHistoryWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getRiskScoreHistoryAPI,
      payload
    );
    yield put(getCRSRiskScoreHistory(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getCRSRiskScoreHistory(error, GET_FAILURE_DATA));
  }
}

export function* watchGetRiskScoreHistoryView() {
  yield takeEvery(GET_CRS_RISK_SCORE_HISTORY, function* ({ payload }) {
    yield fork(getRiskScoreHistoryWorker, payload);
  });
}
/****** RISK SCORE HISTORY SAGA END ********/
